import moment from "moment";
import { CreditReportHistoricalConsumerInformation } from "types/landlord/reports";
import { Section } from "views/applications-id-report/components/Section";

interface HistoricalConsumerInformationProps {
  historical_consumer_information?: CreditReportHistoricalConsumerInformation[];
  isNoHit: boolean;
}
export const HistoricalConsumerInformation = ({
  historical_consumer_information,
  isNoHit
}: HistoricalConsumerInformationProps) => {
  if (isNoHit)
    return (
      <Section sectionTitle="Historical consumer information" maxWidth="none">
        <p className="text-base font-medium text-content-300">
          No data available
        </p>
      </Section>
    );

  return (
    <Section sectionTitle="Historical consumer information" maxWidth="none">
      <div>
        {historical_consumer_information?.length ? (
          <>
            {/* Table header */}
            <div className="flex w-full border-b border-alpha-40">
              <div className="w-full max-w-[470px] py-3.5">
                <p className="text-sm font-medium text-content-300">
                  Address Reported
                </p>
              </div>
              <div className="w-[140px] shrink-0  py-3.5">
                <p className="text-sm font-medium text-content-300">
                  Date Reported
                </p>
              </div>
              <div className="flex w-2/5 justify-end py-3.5">
                <p className="text-sm font-medium text-content-300">
                  Status Reported
                </p>
              </div>
            </div>

            {/* Table body */}
            {[...historical_consumer_information]
              .sort((a, b) => {
                const dateA = a.date_first_reported;
                const dateB = b.date_first_reported;

                if (!dateA || !dateB) return 0;

                return moment(dateB).valueOf() - moment(dateA).valueOf();
              })
              .map((item) => {
                return (
                  <div
                    className="flex w-full border-b border-alpha-40"
                    key={item.address1}
                  >
                    <div className="w-full max-w-[470px] py-3.5">
                      <p className="text-sm font-medium text-content-1000">
                        {`${item.address1}, ${item.city}, ${item.state} ${item.zip}` ||
                          "N/A"}
                      </p>
                    </div>
                    <div className="w-[140px] shrink-0 py-3.5">
                      <p className="text-sm font-medium text-content-1000">
                        {item.date_first_reported || "N/A"}
                      </p>
                    </div>
                    <div className="flex w-2/5 justify-end py-3.5">
                      <p className="text-sm font-medium capitalize text-content-1000">
                        {item.type || "N/A"}
                      </p>
                    </div>
                  </div>
                );
              })}
          </>
        ) : (
          <p className="text-base font-medium">No data available</p>
        )}
      </div>
    </Section>
  );
};
